import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() showMenu: boolean;
  @Output() public menuToggle = new EventEmitter();
  constructor(
    public auth: AuthService,
  ) { }

  ngOnInit() {
  }

  public onMenuToggle = (value) => {
    this.menuToggle.emit(value);
  }
}
